/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getMidanTable = params => {
  return axios.post(`${base}/midan/query`, params)
}
export const getMidanDetail = params => {
  return axios.get(`${base}/midan/get/${params.id}`, {params})
}
export const createMidanData = params => {
  return axios.post(`${base}/midan/create`, params)
}
export const previewMidanData = params => {
  return axios.post(`${base}/midan/preview`, params)
}
export const updateMidanData = params => {
  return axios.post(`${base}/midan/edit/${params.id}`, params)
}
export const updateDynamicsettingMidanData = params => {
  return axios.post(`${base}/midan/dynamicsetting/change/${params.id}`, params)
}
export const previewDynamicsettingMidanData = params => {
  return axios.post(`${base}/midan/dynamicsetting/preview/${params.id}`, params)
}
export const startMidanData = params => {
  return axios.post(`${base}/midan/start/${params.id}`, params)
}
export const stopMidanData = params => {
  return axios.post(`${base}/midan/stop/${params.id}`, params)
}

export const previewInfo = params => {
  return axios.post(`${base}/midan/preview`, params)
}



// WEBPACK FOOTER //
// ./src/views/midan/midan.api.js